<template>
  <div class="footer-container">
    <div class="left">
      <p v-html="left"></p>
      <p class="rightele" v-if="hasbanner()">
        <a href="http://www.justtool.com" v-if="right == '体育竞赛通'"
          ><img :src="logo" /></a
        ><span v-else>{{ right }}</span>
      </p>
    </div>
    <div class="center" v-if="this.$root.VISIBLE">
      {{ $t('footer.FOOTER_CENTER') }}
    </div>
    <div class="right"></div>
    <!-- <div class="right"><img :src="logo" alt="JustTool" v-if="left" /></div> -->
  </div>
</template>

<script>
import * as storage from '../../utils/storage'
import * as constants from '../../constants'
import logo from '../../assets/logo.jpg'

export default {
  name: 'jtFooter',
  data() {
    return {
      logo,
      left: null,
      right: null,
    }
  },
  methods: {
    footerLeft() {
      const config = storage.getItem(constants.GLOBAL_CONFIG)
      return config ? config.gameTips1 : config
    },
    footerRight() {
      const config = storage.getItem(constants.GLOBAL_CONFIG)
      return config ? config.gameTips2 : config
    },

    hasbanner() {
      return storage.getItem('bannerUrl')
    },
    _init() {
      this.left = this.footerLeft()
      this.right = this.footerRight()
    },
  },
  created() {
    this._init()
  },
  watch: {
    $route(to, from) {
      this._init()
    },
  },
}
</script>

<style lang="stylus" scoped>
.footer-container {
  line-height: 2em;
  align-items: center;
  background-color: #435073;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;

  div {
    padding: 0px 8px;
  }
}

.left {
  text-align: left;
  line-height: 22px

  .rightele {
    a {
      display: inline-block;
    }

    img {
      height: 30px;
    }
  }
}

.right {
  img {
    height: 55px;
    margin: 10px;
  }
}

@media screen and (max-width: 768px) {
  .footer-container {
    display: block;
    font-size: 14px;

    div.left {
      text-align: center;
      margin-bottom: 8px;
    }
  }
}
</style>
